export default Object.freeze({
  FACECARE_APP_SCHEME: "com.panasonic.jpe.face-skin-analysis://",
  USER_AGENT_NOT_SMART_PHONE: -1,
  GUEST_ACCOUNT_ID: "guest",
  // 肌分析項目名
  SKIN_ANALYSIS_FEATURES_DICT: {
    firmness: "skinAnalysis.labels.firmness",
    wrinkles: "skinAnalysis.labels.wrinkles",
    darkCirclesV2: "skinAnalysis.labels.darkCirclesV2",
    pore: "skinAnalysis.labels.pore",
    texture: "skinAnalysis.labels.texture",
    ageSpots: "skinAnalysis.labels.ageSpots",
    moisture: "skinAnalysis.labels.moisture",
  },
  // 今日使えるモードのパラメータ
  MODE_PARAMETER: {
    MODE1: {
      LIFT: 0,
      PUMP: 0,
      EYECARE: 1,
      MOIST: 1,
      CLEAN: 1,
    },
    MODE2: {
      LIFT: 0,
      PUMP: 0,
      EYECARE: 0,
      MOIST: 1,
      CLEAN: 1,
    },
    MODE3: {
      LIFT: 1,
      PUMP: 1,
      EYECARE: 0,
      MOIST: 1,
      CLEAN: 1,
    },
    MODE4: {
      LIFT: 1,
      PUMP: 1,
      EYECARE: 1,
      MOIST: 1,
      CLEAN: 1,
    },
  },
  /**
   * 正準判別関数係数
   * [関数1, 関数2, 関数3, 関数4, 関数5, 関数6]
   */
  SKIN_TYPE_FUNCTION_COEFFICIENT: {
    wrinkles: [0.1012, -0.0042, 0.0525, -0.0538, 0.0437, -0.12],
    texture: [0.0763, -0.0499, 0.0288, 0.0521, -0.1898, -0.049],
    darkCirclesV2: [0.0375, 0.0428, 0.1301, 0.0885, 0.0149, 0.0695],
    pore: [0.0738, -0.1155, -0.0725, 0.0695, 0.0915, 0.0057],
    moisture: [0.0308, 0.0594, -0.0397, -0.2542, 0.0575, 0.2697],
    firmness: [0.0547, 0.1066, -0.1276, 0.0213, -0.0098, 0.0148],
    constant_term: [-29.7237, -3.353, 2.0042, 5.0763, 0.5281, -12.9308],
  },
  /**
   * 重心行列の設定
   * [関数1, 関数2, 関数3, 関数4, 関数5, 関数6]
   */
  SKIN_TYPE_CENTROID_MATRIX: {
    CL1: [-1.3445, -2.0928, 1.2612, -0.1794, 0.2115, -0.0205],
    CL2: [-0.8544, 2.0987, 1.0022, -0.8898, -0.2556, -0.011],
    CL3: [-3.5292, -0.2522, 0.1908, 0.2638, -0.2337, 0.0197],
    CL4: [3.1788, -0.5396, 0.0299, 0.0335, -0.1814, 0.0042],
    CL5: [-0.7961, -0.6304, -1.6749, -0.5497, 0.1823, 0.0134],
    CL6: [-0.2062, 0.7104, -0.378, 0.2574, 0.084, -0.0151],
    CL7: [1.7746, 1.3582, 1.444, 0.0979, 0.5608, 0.0431],
  },

  // エラーメッセージ
  COMMON_SYSTEM_ERROR_MSG: "errorMessage.commonSystemError",
  OFFLINE_ERROR_MSG: "errorMessage.offlineError",
  ERROR_CODE_GUIDE: "errorMessage.errorCodeGuide",

  // i18n
  DEFAULT_COUNTRY: "jp",
  DEFAULT_LOCALE: "ja",
});
